var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "w-100" },
    [
      _c(
        "div",
        {
          staticClass: "container-fluid fixed-top w-100 px-0",
          staticStyle: { "z-index": "10" },
          attrs: { id: "nav-info", role: "navigation" }
        },
        [_c("interview-navi", { attrs: { navData: _vm.pageData } })],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          class: {
            "quote-panel-open": _vm.quotePanelStatus,
            "quote-panel-close": !_vm.quotePanelStatus,
            bundle:
              _vm.flowType === "bundle" ||
              _vm.flowType === "cabundle" ||
              _vm.flowType === "rabundle"
          },
          attrs: { role: "main" }
        },
        [
          _c(
            "form",
            {
              on: {
                keydown: function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  $event.preventDefault()
                  return _vm.submitted($event)
                }
              }
            },
            [
              _vm._m(0),
              _vm._v(" "),
              _vm.blurbs.formtop && _vm.blurbs.formtop.visible
                ? _c(
                    "div",
                    {
                      staticClass: "d-flex justify-content-center mx-auto mb-1"
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "alert alert-primary my-0 py-2 w-50",
                          attrs: { role: "note" }
                        },
                        [
                          _c("div", { staticClass: "row no-gutters" }, [
                            _vm._m(1),
                            _vm._v(" "),
                            _c("div", {
                              staticClass:
                                "col d-inline-block my-auto smaller-font-content",
                              domProps: {
                                innerHTML: _vm._s(_vm.blurbs.formtop.content)
                              }
                            })
                          ])
                        ]
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "container-fluid mt-1 px-0" }, [
                _c("div", { staticClass: "row mx-0 bg-white" }, [
                  _c("div", { staticClass: "col-12 px-0 text-left" }, [
                    _c("div", { staticClass: "row mx-0" }, [
                      _c("div", { staticClass: "col-12 px-0" }, [
                        _c("div", { staticClass: "row no-gutters" }, [
                          _vm._m(2),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-12 pt-2 mb-3 pol-lev-que shadow-sm rounded",
                              attrs: { id: "form-block" }
                            },
                            _vm._l(_vm.polCovArr, function(subItem, subKey) {
                              return _c("form-block", {
                                key: subKey + "_pol_fld_cnt",
                                ref: subItem.field_name,
                                refInFor: true,
                                staticClass: "form-group mx-3",
                                attrs: { formdata: subItem }
                              })
                            }),
                            1
                          )
                        ])
                      ])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _vm._m(3),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "scrolling-wrapper bg-white",
                    attrs: { id: "carousel-vehicle-top-scrollbar" }
                  },
                  _vm._l(_vm.pageFieldsArray, function(vitem, vkey) {
                    return _c("div", {
                      key: vkey + "_veh_cnt",
                      staticClass: "cardItem col-md-3"
                    })
                  }),
                  0
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "scrolling-wrapper pt-3 bg-white",
                    class: {
                      "spacefor-tooltip": _vm.pageFieldsArray.length > 1
                    },
                    attrs: { id: "carousel-vehicle-headings" }
                  },
                  _vm._l(_vm.pageFieldsArray, function(vitem, vkey) {
                    return _c(
                      "div",
                      {
                        key: vkey + "_veh_cnt",
                        staticClass: "cardItem col-md-3"
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "form-row py-2 pl-3 mx-0 bg-ltblue text-white rounded-top h-100",
                            attrs: { id: "vehAcc_" + vkey }
                          },
                          [
                            _c("div", { staticClass: "col p-0" }, [
                              _c(
                                "div",
                                {
                                  class: {
                                    "more-vehicles":
                                      _vm.pageFieldsArray.length > 1
                                  },
                                  attrs: { role: "heading", "aria-level": "3" }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.getAccordianLabel(
                                        _vm.pageFieldsArray,
                                        vkey
                                      )
                                    )
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            vkey === 0 &&
                            _vm.pageFieldsArray.length > 1 &&
                            _vm.applyToAllBtn.status === "Visible"
                              ? _c(
                                  "div",
                                  { staticClass: "col text-right" },
                                  [
                                    _vm.$store.state.buttonState
                                      .quoteSummaryData &&
                                    _vm.$store.state.buttonState
                                      .quoteSummaryData.quote_status !== "Bound"
                                      ? _c(
                                          "button",
                                          {
                                            staticClass:
                                              "btn btn-primary applyToAll",
                                            attrs: {
                                              id: "applyToAllTooltip",
                                              "aria-label":
                                                "copy vehicle coverage",
                                              tabindex: "0"
                                            },
                                            on: {
                                              keydown: function($event) {
                                                if (
                                                  !$event.type.indexOf("key") &&
                                                  _vm._k(
                                                    $event.keyCode,
                                                    "enter",
                                                    13,
                                                    $event.key,
                                                    "Enter"
                                                  )
                                                ) {
                                                  return null
                                                }
                                                $event.preventDefault()
                                                $event.stopPropagation()
                                                return _vm.openRemoveModal(
                                                  "copy-vehicle-coverage-modal",
                                                  _vm.applyToAllBtn.on_click
                                                )
                                              },
                                              click: function($event) {
                                                $event.preventDefault()
                                                return _vm.openRemoveModal(
                                                  "copy-vehicle-coverage-modal",
                                                  _vm.applyToAllBtn.on_click
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  _vm.applyToAllBtn.label
                                                ) +
                                                "\n                  "
                                            ),
                                            _c(
                                              "svg",
                                              {
                                                attrs: {
                                                  xmlns:
                                                    "http://www.w3.org/2000/svg",
                                                  width: "16",
                                                  height: "16",
                                                  viewBox: "0 0 16 16",
                                                  fill: "none"
                                                }
                                              },
                                              [
                                                _c("path", {
                                                  attrs: {
                                                    d:
                                                      "M5 5.75C5 4.78503 5.78506 4 6.75 4H11V1.75C11 1.33578 10.6642 1 10.25 1H7.73094C7.38456 0.402812 6.73866 0 6 0C5.26134 0 4.61544 0.402812 4.26906 1H1.75C1.33578 1 1 1.33578 1 1.75V12.25C1 12.6642 1.33578 13 1.75 13H5V5.75ZM6 1.25C6.41422 1.25 6.75 1.58578 6.75 2C6.75 2.41422 6.41422 2.75 6 2.75C5.58578 2.75 5.25 2.41422 5.25 2C5.25 1.58578 5.58578 1.25 6 1.25ZM11.75 9H15V15.25C15 15.6642 14.6642 16 14.25 16H6.75C6.33578 16 6 15.6642 6 15.25V5.75C6 5.33578 6.33578 5 6.75 5H11V8.25C11 8.6625 11.3375 9 11.75 9ZM15 7.81066V8H12V5H12.1893C12.3882 5 12.579 5.07901 12.7197 5.21966L14.7803 7.28031C14.921 7.42097 15 7.61174 15 7.81066Z",
                                                    fill: "currentColor"
                                                  }
                                                })
                                              ]
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "b-tooltip",
                                      {
                                        attrs: {
                                          target: "applyToAllTooltip",
                                          triggers: "focus hover",
                                          placement: "bottom"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                  Apply the current coverage selections on this vehicle to all vehicle's current selections.\n                "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              : _vm._e()
                          ]
                        )
                      ]
                    )
                  }),
                  0
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "container-fluid sm-margin" }, [
                _c(
                  "div",
                  {
                    staticClass: "row scrolling-wrapper pb-5",
                    class: {
                      "position-relative top-48": _vm.pageFieldsArray.length > 1
                    },
                    attrs: { id: "carousel-vehicle" }
                  },
                  _vm._l(_vm.pageFieldsArray, function(vitem, vkey) {
                    return _c(
                      "div",
                      {
                        key: vkey + "_veh_cnt",
                        staticClass: "cardItem col-md-3"
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "form-row mx-0 py-3 accordPanel shadow-sm rounded-bottom",
                            attrs: { id: "vehAccPanel_" + vkey }
                          },
                          [
                            _c("div", { staticClass: "col px-0" }, [
                              _c("div", { staticClass: "form-row mx-0" }, [
                                _c(
                                  "div",
                                  { staticClass: "col px-0" },
                                  _vm._l(vitem, function(subItem, subKey) {
                                    return _c("form-block", {
                                      key: subKey + "_veh_fld_cnt",
                                      ref: subItem.field_name,
                                      refInFor: true,
                                      staticClass: "form-group mx-3",
                                      attrs: { formdata: subItem }
                                    })
                                  }),
                                  1
                                )
                              ])
                            ])
                          ]
                        )
                      ]
                    )
                  }),
                  0
                ),
                _vm._v(" "),
                _c("div", { staticClass: "row no-gutters" }, [
                  _c("div", { staticClass: "col-12" }, [
                    _c("hr"),
                    _vm._v(" "),
                    _vm.blurbs.formbottom && _vm.blurbs.formbottom.visible
                      ? _c(
                          "div",
                          {
                            staticClass: "d-flex justify-content-center mx-auto"
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "alert alert-primary my-0 py-2 w-50",
                                attrs: { role: "note" }
                              },
                              [
                                _c("div", { staticClass: "row no-gutters" }, [
                                  _vm._m(4),
                                  _vm._v(" "),
                                  _c("div", {
                                    staticClass:
                                      "col d-inline-block my-auto smaller-font-content",
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.blurbs.formbottom.content
                                      )
                                    }
                                  })
                                ])
                              ]
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.getContinueLabelName() != "" && _vm.continueEnabled
                      ? _c(
                          "div",
                          {
                            staticClass: "row justify-content-center mx-0 my-3"
                          },
                          [
                            _c("div", { staticClass: "col-8 text-center" }, [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-primary",
                                  attrs: { type: "submit" },
                                  on: {
                                    click: function($event) {
                                      $event.preventDefault()
                                      return _vm.submitted($event)
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(_vm.getContinueLabelName()))]
                              )
                            ])
                          ]
                        )
                      : _vm._e()
                  ])
                ])
              ])
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c("dev-auto-fill", { attrs: { pageData: _vm.pageData } }),
      _vm._v(" "),
      _vm.$store.state.buttonState.quoteSummaryData &&
      _vm.$store.state.buttonState.quoteSummaryData.quote_status === "Bound"
        ? _c("form-alerts", {
            class: {
              "policy-bound-alert": true,
              "margin-25": _vm.quotePanelStatus
            },
            attrs: { pageData: _vm.policyBindError }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "copy-vehicle-coverage-modal",
          attrs: {
            "hide-header": "",
            "hide-footer": "",
            "hide-header-close": "",
            "no-enforce-focus": ""
          }
        },
        [
          _c("Trap", [
            _c("div", { staticClass: "copy-vehicle-coverage-modal" }, [
              _c("div", { staticClass: "remove-modal-message mb-1" }, [
                _c("div", [_vm._v("Apply this coverage to all vehicles?")])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "modal-message mb-3" }, [
                _c("div", [
                  _vm._v(
                    "This feature copies the coverage information to the rest of the vehicles. Edits can still be made on each vehicle."
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "remove-modal-sep mt-1 mb-1" }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "remove-btn-box" },
                [
                  _c(
                    "b-button",
                    {
                      staticClass:
                        "mt-3 remove-btn-cancel remove-cust-btn modal-cancel-button",
                      attrs: { block: "" },
                      on: {
                        click: function($event) {
                          return _vm.closeRemoveModal(
                            "copy-vehicle-coverage-modal"
                          )
                        }
                      }
                    },
                    [_vm._v("Cancel")]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      staticClass:
                        "mt-3 remove-btn-confirm remove-cust-btn modal-button",
                      attrs: { block: "" },
                      on: {
                        click: function($event) {
                          return _vm.removeRule("copy-vehicle-coverage-modal")
                        }
                      }
                    },
                    [_vm._v("\n            Apply to All")]
                  )
                ],
                1
              )
            ])
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "required row mx-0" }, [
      _c("div", { staticClass: "col-12 px-0 text-left" }, [
        _c("span", { staticClass: "star" }, [_vm._v("*")]),
        _vm._v("Required to run carrier quotes.\n          "),
        _c("hr")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "d-inline-block pr-2 my-auto" }, [
      _c("img", {
        attrs: {
          width: "25px",
          height: "25px",
          src: require("../../../../assets/info-circle-blue.svg"),
          alt: "info"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "col-12 py-2 pl-2 bg-ltblue text-white rounded-top" },
      [
        _c("div", { attrs: { role: "heading", "aria-level": "2" } }, [
          _vm._v("Policy Coverage")
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "col-12 py-2 pl-2 mt-2 bg-ltblue text-white rounded-top" },
      [
        _c("div", { attrs: { role: "heading", "aria-level": "2" } }, [
          _vm._v("Vehicle Coverage")
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "d-inline-block pr-2 my-auto" }, [
      _c("img", {
        attrs: {
          width: "25px",
          height: "25px",
          src: require("../../../../assets/info-circle-blue.svg"),
          alt: "info"
        }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3c8cbac8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c8cbac8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/interview/Auto/RC1/NewCoverages.vue
// module id = null
// module chunks = 